export enum QRCodeType {
    EPC = 'epc',
    SWISS = 'swiss',
}
